// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gridContainer_FQqUn {
  display : grid;
  grid-template-columns: auto auto;
  column-gap : var( --size-padLarge, 16px );
}

.gridItem_qQjze {
  display : flex;
  flex-direction : column;
}

.right_BZNg6 {
  min-width : 400px;
  border-left : 3px solid var( --color-base100, #eeeeee );
  margin-left : var( --size-padLarge, 16px );
  padding-left : var( --size-padLarge, 16px );
} 

.listItem_TtCcn {
  background : transparent !important; 
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-user-management/lib/role/RoleSelector.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uDAAuD;EACvD,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".gridContainer {\n  display : grid;\n  grid-template-columns: auto auto;\n  column-gap : var( --size-padLarge, 16px );\n}\n\n.gridItem {\n  display : flex;\n  flex-direction : column;\n}\n\n.right {\n  min-width : 400px;\n  border-left : 3px solid var( --color-base100, #eeeeee );\n  margin-left : var( --size-padLarge, 16px );\n  padding-left : var( --size-padLarge, 16px );\n} \n\n.listItem {\n  background : transparent !important; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `gridContainer_FQqUn`,
	"gridItem": `gridItem_qQjze`,
	"right": `right_BZNg6`,
	"listItem": `listItem_TtCcn`
};
export default ___CSS_LOADER_EXPORT___;
